// @flow
import NewsletterCategory from 'components/newsletter/NewsletterCategory';
import { connect } from 'react-redux';

import { fetchArticlesCategory } from 'actions/newsletterCategoryActions';
import { fetchGenericSidebar } from 'actions/sidebarActions';
import type { DispatchType, StateType } from 'types/Actions';
import type { DispatchProps, StateProps } from 'components/newsletter/NewsletterCategory';

export default connect(
  (state: StateType, ownProps): StateProps => ({
    status: state.newsletterCategoryState.status,
    articleNumber: state.newsletterCategoryState.articleNumber,
    articles: state.newsletterCategoryState.articles,
    categories: state.categoriesState.categories,
    sidebar: state.sidebarState,
    ligue: state.settingsState.ligue
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchArticlesCategory: (page: number, per_page: number, category: string) =>
      dispatch(fetchArticlesCategory(page, per_page, category)),
    fetchGenericSidebar: () => dispatch(fetchGenericSidebar()),
  })
)(NewsletterCategory);
